document.addEventListener("DOMContentLoaded", function() {
  const menuLinks = document.querySelectorAll(".header-navigation__mega-menu__list-item a");
  
  menuLinks.forEach(link => {
    link.addEventListener("mouseenter", function() {
      // Remove exit class and set transform-origin to left (entry from left)
      this.classList.remove("exit-from-left");
    });
    
    link.addEventListener("mouseleave", function() {
      // Add exit class to set transform-origin to right (exit from left to right)
      this.classList.add("exit-from-left");
      
      // After animation completes, reset for the next hover entry
      setTimeout(() => {
        if (!this.matches(":hover")) {
          this.classList.remove("exit-from-left");
        }
      }, 300); // Match the transition duration
    });
  });
}); 